<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="header">
    <div class="top-nav-container">
      <button class="top-nav-toggle" @click="toggleTopNav">
        <span>更多</span>
        <i class="toggle-icon" :class="{ 'open': showTopNav }">▼</i>
      </button>
      <div class="top-nav" :class="{ 'show-top-nav': showTopNav }">
        <router-link to="/" class="top-nav-link">首页</router-link>
        <!-- <a href="https://cg-csdl.com/" target="_blank" class="top-nav-link">动漫衍生品商城</a> -->
        <router-link to="/page/vr" class="top-nav-link">虚拟展馆</router-link>
        
        <!-- 添加登录/注册按钮 -->
        <div class="auth-links">
          <template v-if="isAuthenticated">
            <span class="user-info" :title="userTooltip">
              欢迎，{{ displayName }}

            </span>
            <router-link to="/profile" class="top-nav-link">个人中心</router-link>
            <a href="#" class="top-nav-link" @click.prevent="logout">退出</a>
          </template>
          <template v-else>
            <a href="#" class="top-nav-link" @click.prevent="showLoginModal = true">登录</a>
            <!--<a href="#" class="top-nav-link" @click.prevent="showRegisterModal = true">注册</a> -->
          </template>
        </div>
      </div>
    </div>

    <div class="slider-wrapper">
      <Slider />
    </div>

    <div class="search-container">
      <div class="search-box">
        <input 
          type="text" 
          v-model="searchQuery" 
          @keyup.enter="performSearch"
          placeholder="搜索课程、资源或软件..." 
          class="search-input"
        />
        <button @click="performSearch" class="search-button">
          <i class="search-icon">🔍</i>
        </button>
      </div>
      <div class="quick-links">
        <span class="quick-link" @click="gotoHomework">作业提交</span>
        <span class="quick-link" @click="gotoSoftPage">AI生成ppt</span>
        <span class="quick-link" @click="gotoKnowledgeGraph">动画专业知识图谱</span>
      </div>
    </div>

    <nav class="navbar">
      <button class="mobile-menu-btn" :class="{ 'active': showMobileMenu }" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <ul :class="{ 'show-mobile-menu': showMobileMenu }">
        <li><router-link to="/" :class="{ active: $route.path === '/' }">课程学习</router-link></li>
        <li><router-link to="/page/software" :class="{ active: $route.path === '/page/software' }">常用软件</router-link></li>
        <li><router-link to="/page/resourse" :class="{ active: $route.path === '/page/resourse' }">素材资源</router-link></li>
        <li><router-link to="/page/byjy" :class="{ active: $route.path === '/page/byjy' }">毕业就业</router-link></li>
        <li><router-link to="/page/rcbg" :class="{ active: $route.path === '/page/rcbg' }">日常办公</router-link></li>
      </ul>
    </nav>

    <!-- 登录弹窗 -->
    <div class="modal" v-if="showLoginModal" @click.self="showLoginModal = false">
      <div class="modal-content">
        <span class="close-btn" @click="showLoginModal = false">&times;</span>
        <div class="login-container">
          <div class="login-form">
            <h2>用户登录</h2>
            <div v-if="loginError" class="error-message">{{ loginError }}</div>
            <form @submit.prevent="handleLogin">
              <div class="form-group">
                <label for="username">用户名</label>
                <input 
                  type="text" 
                  id="username" 
                  v-model="loginForm.username" 
                  required 
                  placeholder="请输入用户名"
                  autocomplete="username"
                />
              </div>
              <div class="form-group">
                <label for="password">密码</label>
                <input 
                  type="password" 
                  id="password" 
                  v-model="loginForm.password" 
                  required 
                  placeholder="请输入密码"
                  autocomplete="current-password"
                />
              </div>
              <!-- 验证码部分已移除 -->
              <!--<div class="form-group">
                <label class="checkbox-label">
                  <input type="checkbox" v-model="loginForm.rememberMe">
                  <span>记住我</span>
                </label>
              </div> -->
              <button type="submit" class="login-button" :disabled="loginLoading">
                {{ loginLoading ? '登录中...' : '登录' }}
              </button>
            </form>
        <!--    <div class="form-footer">
              <p>还没有账号？ <a href="#" @click.prevent="switchToRegister">立即注册</a></p>
            </div> -->
          </div>
          <!-- <div class="social-login">
            <p>或使用以下方式登录</p>
            <div class="social-buttons">
              <button type="button" class="social-btn wechat" @click="socialLogin('wechat')">
                <i class="icon-wechat"></i> 微信登录
              </button>
              <button type="button" class="social-btn qq" @click="socialLogin('qq')">
                <i class="icon-qq"></i> QQ登录
              </button>
            </div>
          </div>-->
        </div>
      </div>
    </div>

    <!-- 注册弹窗 -->
    <div class="modal" v-if="showRegisterModal" @click.self="showRegisterModal = false">
      <div class="modal-content">
        <span class="close-btn" @click="showRegisterModal = false">&times;</span>
        <div class="register-container">
          <div class="register-form">
            <h2>用户注册</h2>
            <div v-if="registerError" class="error-message">{{ registerError }}</div>
            <div v-if="registerSuccess" class="success-message">{{ registerSuccess }}</div>
            <form @submit.prevent="handleRegister">
              <div class="form-group">
                <label for="reg-username">用户名</label>
                <input 
                  type="text" 
                  id="reg-username" 
                  v-model="registerForm.username" 
                  required 
                  placeholder="请输入用户名"
                  autocomplete="username"
                />
              </div>
              <div class="form-group">
                <label for="reg-email">邮箱</label>
                <input 
                  type="email" 
                  id="reg-email" 
                  v-model="registerForm.email" 
                  required 
                  placeholder="请输入邮箱"
                  autocomplete="email"
                />
              </div>
              <div class="form-group">
                <label for="reg-password">密码</label>
                <input 
                  type="password" 
                  id="reg-password" 
                  v-model="registerForm.password" 
                  required 
                  placeholder="请输入密码"
                  @input="checkPasswordStrength"
                  autocomplete="new-password"
                />
                <div class="password-strength" v-if="registerForm.password">
                  <div class="strength-bar">
                    <div 
                      class="strength-level" 
                      :style="{width: passwordStrength + '%'}"
                      :class="strengthClass"
                    ></div>
                  </div>
                  <span class="strength-text">{{ strengthText }}</span>
                </div>
              </div>
              <div class="form-group">
                <label for="reg-confirmPassword">确认密码</label>
                <input 
                  type="password"
                  id="reg-confirmPassword"
                  v-model="registerForm.confirmPassword"
                  required
                  placeholder="请再次输入密码"
                  autocomplete="new-password"
                />
              </div>
              <button type="submit" class="register-button" :disabled="registerLoading">
                {{ registerLoading ? '注册中...' : '注册' }}
              </button>
            </form>
            <div class="form-footer">
              <p>已有账号？ <a href="#" @click.prevent="switchToLogin">立即登录</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Slider from './Slider.vue';

export default {
  components: {
    Slider
  },
  data() {
    return {
      showMobileMenu: false,
      showTopNav: false,
      searchQuery: '',
      showLoginModal: false,
      showRegisterModal: false,
      loginForm: {
        username: '',
        password: '',
        rememberMe: false
      },
      registerForm: {
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
      },
      loginError: '',
      registerError: '',
      registerSuccess: '',
      loginLoading: false,
      registerLoading: false,
      passwordStrength: 0,
      strengthClass: '',
      strengthText: '',
      localUserInfo: null // 本地用户信息状态
    };
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'currentUser', 'userDisplayName', 'userInfo', 'isLoading']),
    
    // 显示名称
    displayName() {
      // 优先使用本地状态，然后是store中的信息
      const user = this.localUserInfo || this.currentUser
      if (!user) return '未知用户'
      
      // 优先级：yhm > username > email前缀 > 默认值
      if (user.yhm) return user.yhm
      if (user.username) return user.username
      if (user.email) {
        const emailPrefix = user.email.split('@')[0]
        return emailPrefix || '未知用户'
      }
      return '未知用户'
    },
    
    // 用户提示信息
    userTooltip() {
      const user = this.localUserInfo || this.currentUser
      if (!user) return ''
      
      let tooltip = []
      if (user.yhm) tooltip.push(`用户名: ${user.yhm}`)
      if (user.username && user.username !== user.yhm) tooltip.push(`登录名: ${user.username}`)
      if (user.email) tooltip.push(`邮箱: ${user.email}`)
      
      return tooltip.join('\n')
    },
    
    // 是否正在加载用户信息
    isLoadingUserInfo() {
      return this.isLoading.userInfo || this.isLoading.login
    }
  },
  
  watch: {
    // 监听当前用户变化
    currentUser: {
      handler(newUser) {
        if (newUser) {
          this.localUserInfo = { ...newUser }
        } else {
          this.localUserInfo = null
        }
      },
      immediate: true,
      deep: true
    },
    
    // 监听用户信息变化
    userInfo: {
      handler(newUserInfo) {
        if (newUserInfo) {
          this.localUserInfo = { ...newUserInfo }
        }
      },
      immediate: true,
      deep: true
    }
  },
  
  created() {
    // 初始化应用
    this.$store.dispatch('initApp')
    
    // 如果用户已登录，获取最新的用户信息
    if (this.isAuthenticated) {
      this.$store.dispatch('fetchUserInfo')
    }
  },
  
  methods: {
    toggleMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    toggleTopNav() {
      this.showTopNav = !this.showTopNav;
    },
    gotoHomework() {
      this.$router.push('/file-upload');
    },
    gotoSoftPage() {
      this.$router.push('/page/software');
    },
    gotoKnowledgeGraph() {
      this.$router.push('/knowledge-graph');
    },
    
    async handleLogin() {
      this.loginError = ''
      this.loginLoading = true
      
      // 验证表单
      if (!this.loginForm.username || !this.loginForm.password) {
        this.loginError = '请填写用户名和密码'
        this.loginLoading = false
        return
      }
      
      try {
        // 调用登录接口
        await this.$store.dispatch('login', {
          username: this.loginForm.username,
          password: this.loginForm.password,
          rememberMe: this.loginForm.rememberMe
        })
        
        // 登录成功
        console.log('登录成功，用户名：', this.displayName)
        
        // 关闭弹窗并重置表单
        this.showLoginModal = false
        this.resetLoginForm()
        
        // 显示成功消息（可选）
        this.$nextTick(() => {
          console.log('用户信息已更新:', this.localUserInfo)
        })
      } catch (error) {
        this.loginError = error.message || '登录失败，请检查用户名和密码'
      } finally {
        this.loginLoading = false
      }
    },
    
    handleRegister() {
      this.registerError = ''
      this.registerSuccess = ''
      this.registerLoading = true
      
      // 验证表单
      if (!this.registerForm.username || !this.registerForm.email || !this.registerForm.password) {
        this.registerError = '请填写所有必填字段'
        this.registerLoading = false
        return
      }
      
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.registerError = '两次输入的密码不一致'
        this.registerLoading = false
        return
      }
      
      if (this.passwordStrength < 40) {
        this.registerError = '密码强度太弱，请使用更复杂的密码'
        this.registerLoading = false
        return
      }
      
      // 调用注册接口
      this.$store.dispatch('register', {
        username: this.registerForm.username,
        email: this.registerForm.email,
        password: this.registerForm.password
      })
      .then(() => {
        this.registerSuccess = '注册成功！请登录'
        setTimeout(() => {
          this.switchToLogin()
        }, 2000)
      })
      .catch(error => {
        this.registerError = error.message || '注册失败，请稍后再试'
      })
      .finally(() => {
        this.registerLoading = false
      })
    },
    
    resetLoginForm() {
      this.loginForm = {
        username: '',
        password: '',
        rememberMe: false
      }
      this.loginError = ''
    },
    
    resetRegisterForm() {
      this.registerForm = {
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
      }
      this.registerError = ''
      this.registerSuccess = ''
      this.passwordStrength = 0
    },
    
    checkPasswordStrength() {
      const password = this.registerForm.password
      let strength = 0
      
      // 长度检查
      if (password.length >= 6) strength += 20
      if (password.length >= 10) strength += 10
      
      // 复杂度检查
      if (/[A-Z]/.test(password)) strength += 20 // 大写字母
      if (/[a-z]/.test(password)) strength += 15 // 小写字母
      if (/[0-9]/.test(password)) strength += 15 // 数字
      if (/[^A-Za-z0-9]/.test(password)) strength += 20 // 特殊字符
      
      this.passwordStrength = Math.min(strength, 100)
      
      // 设置强度等级和文本
      if (this.passwordStrength < 40) {
        this.strengthClass = 'weak'
        this.strengthText = '弱'
      } else if (this.passwordStrength < 70) {
        this.strengthClass = 'medium'
        this.strengthText = '中'
      } else {
        this.strengthClass = 'strong'
        this.strengthText = '强'
      }
    },
    
    switchToLogin() {
      this.showRegisterModal = false
      this.resetRegisterForm()
      this.showLoginModal = true
    },
    
    // 退出登录
    logout() {
      this.localUserInfo = null
      this.$store.dispatch('logout')
      this.$router.push('/') // 跳转到首页
    },

    performSearch() {
      if (!this.searchQuery.trim()) return;
      
      const query = this.searchQuery.toLowerCase();
      
      const routes = [
        { 
          path: '/', 
          keywords: ['课程', '学习', '动画', '素描', '色彩', '动画素描', '动画基础', '动画设计', '动画制作', '动画原理', '动画技法',
            '教程', '视频教程', '动画教程', '绘画', '绘画基础', '插画', '漫画', '角色设计', '场景设计', '分镜', '分镜头',
            '动画分镜', '动画剧本', '动画脚本', '动画故事板', '故事板', '动画场景', '动画角色', '动画人物', '人物设计',
            '动画运动规律', '运动规律', '动画表演', '表演原理', '动画表情', '表情设计', '动画动作', '动作设计', '动画特效',
            '特效动画', '动画灯光', '灯光设计', '动画渲染', '渲染技术', '动画后期', '后期制作', '动画合成', '合成技术',
            '动画配音', '配音技巧', '动画音效', '音效设计', '动画配乐', '配乐设计', '动画剪辑', '剪辑技巧', '动画调色',
            '调色技术', '动画输出', '输出格式', '动画压缩', '视频压缩', '动画发布', '视频发布', '课程学习', '学习资料',
            '教学视频', '教学资料', '学习笔记', '笔记分享', '课程笔记', '课程资料', '课程作业', '作业参考', '作业案例',
            '优秀作业', '优秀案例', '优秀作品', '作品分析', '作品赏析', '作品点评', '作品评价', '作品评论', '作品讨论',
            '课程讨论', '课程问答', '课程答疑', '课程交流', '学习交流', '学习讨论', '学习问答', '学习答疑', '学习心得',
            '学习体会', '学习经验', '学习方法', '学习技巧', '学习路径', '学习计划', '学习规划', '学习目标', '学习成果',
            '学习效果', '学习评价', '学习评估', '学习反馈', '学习总结', '课程总结', '课程评价', '课程评估', '课程反馈',
            '动画专业', '动画课程', '动画学习', '动画技术', '动画理论', '动画实践', '动画作品', '动画项目', '动画练习',
            '动画训练', '动画创作', '动画创意', '动画思维', '动画思路', '动画方法', '动画流程', '动画工作流', '动画制作流程',
            '动画制作方法', '动画制作技巧', '动画制作经验', '动画制作心得', '动画制作体会', '动画制作总结', '动画制作评价',
            '动画制作评估', '动画制作反馈', '动画制作问题', '动画制作解决方案', '动画制作案例', '动画制作实例', '动画制作示例',
            '动画制作参考', '动画制作借鉴', '动画制作启发', '动画制作灵感', '动画制作创意', '动画制作思路', '动画制作方向',
            '动画制作趋势', '动画制作潮流', '动画制作风格', '动画制作特色', '动画制作特点', '动画制作特征', '动画制作属性',
            '动画制作性质', '动画制作品质', '动画制作质量', '动画制作水平', '动画制作档次', '动画制作等级', '动画制作级别',
            '动画制作标准', '动画制作规范', '动画制作规格', '动画制作尺寸', '动画制作大小', '动画制作容量', '动画制作空间',
            '动画制作存储', '动画制作保存', '动画制作备份', '动画制作恢复', '动画制作还原', '动画制作修复', '动画制作维护'],
          weight: 1.2 // 给主页一个较高的权重
        },
        { 
          path: '/page/software', 
          keywords: ['软件', 'photoshop', 'illustrator', 'premiere', 'after effects', 'ae', 'ps', 'ai', 'pr', '3d max', 'maya', 'blender', 
            '软件下载', '设计软件', '编辑软件', '动画软件', '3d软件', '渲染软件', '建模软件', '贴图软件', '纹理软件', '材质软件',
            '动画制作软件', '视频编辑软件', '图像处理软件', '矢量图形软件', '三维建模软件', '三维动画软件', '特效软件', '合成软件',
            '剪辑软件', '调色软件', '音频编辑软件', '音效软件', '配音软件', '配乐软件', '字幕软件', '压缩软件', '格式转换软件',
            'c4d', 'cinema 4d', 'substance painter', 'substance designer', 'zbrush', 'houdini', 'nuke', 'davinci resolve',
            'audition', 'au', 'animate', 'flash', 'character animator', 'indesign', 'id', 'acrobat', 'lightroom', 'lr',
            'bridge', 'media encoder', 'dimension', 'xd', 'fresco', 'dreamweaver', 'dw', 'figma', 'sketch', 'procreate',
            'clip studio paint', 'csp', 'painter', 'corel painter', 'corel draw', 'affinity designer', 'affinity photo',
            'affinity publisher', 'tvpaint', 'toon boom', 'harmony', 'storyboard pro', 'moho', 'anime studio', 'spine',
            'dragonbones', 'live2d', 'unity', 'unreal engine', 'ue', 'godot', 'gamemaker', 'construct', 'rpg maker',
            '软件教程', '软件使用', '软件技巧', '软件快捷键', '软件插件', '软件预设', '软件模板', '软件素材', '软件资源',
            '软件安装', '软件激活', '软件破解', '软件汉化', '软件更新', '软件升级', '软件兼容', '软件问题', '软件故障',
            '软件修复', '软件优化', '软件设置', '软件配置', '软件推荐', '软件对比', '软件评测', '软件评价', '软件评论',
            'adobe', '动画软件', '视频软件', '图像软件', '音频软件', '3d软件', '渲染器', '渲染引擎', '建模工具', '动画工具',
            '特效工具', '合成工具', '剪辑工具', '调色工具', '音频工具', '配音工具', '配乐工具', '字幕工具', '压缩工具',
            '格式转换工具', '软件下载地址', '软件安装包', '软件安装教程', '软件使用教程', '软件使用方法', '软件使用技巧',
            '软件使用心得', '软件使用体会', '软件使用经验', '软件使用总结', '软件使用评价', '软件使用评估', '软件使用反馈',
            '软件使用问题', '软件使用解决方案', '软件使用案例', '软件使用实例', '软件使用示例', '软件使用参考', '软件使用借鉴',
            '软件使用启发', '软件使用灵感', '软件使用创意', '软件使用思路', '软件使用方向', '软件使用趋势', '软件使用潮流',
            '软件使用风格', '软件使用特色', '软件使用特点', '软件使用特征', '软件使用属性', '软件使用性质', '软件使用品质',
            '软件使用质量', '软件使用水平', '软件使用档次', '软件使用等级', '软件使用级别', '软件使用标准', '软件使用规范',
            '软件使用规格', '软件使用尺寸', '软件使用大小', '软件使用容量', '软件使用空间', '软件使用存储', '软件使用保存',
            '软件使用备份', '软件使用恢复', '软件使用还原', '软件使用修复', '软件使用维护', '软件使用保养', '软件使用养护',
            '软件使用保护', '软件使用安全', '软件使用隐私', '软件使用机密', '软件使用秘密', '软件使用私有', '软件使用公开',
            '软件使用公共', '软件使用共享', '软件使用开放', '软件使用免费', '软件使用收费', '软件使用付费', '软件使用订阅',
            '软件使用会员', '软件使用VIP', '软件使用特权', '软件使用福利', '软件使用优惠', '软件使用折扣', '软件使用促销',
            '软件使用活动', '软件使用赠送', '软件使用奖励', '软件使用激励', '软件使用鼓励', '软件使用支持', '软件使用帮助',
            '软件使用辅助', '软件使用工具', '软件使用插件', '软件使用扩展', '软件使用扩充', '软件使用增强', '软件使用增加',
            '软件使用添加', '软件使用补充', '软件使用完善', '软件使用改进', '软件使用改善', '软件使用提升', '软件使用提高',
            '软件使用升级', '软件使用更新', '软件使用修改', '软件使用调整', '软件使用优化', '软件使用美化', '软件使用美工',
            '软件使用设计', '软件使用创作', '软件使用创造', '软件使用制作', '软件使用生成', '软件使用产生', '软件使用输出',
            '软件使用输入', '软件使用采集', '软件使用获取', '软件使用提取', '软件使用抽取', '软件使用提炼', '软件使用精炼',
            '软件使用精选', '软件使用筛选', '软件使用挑选', '软件使用选择', '软件使用决策', '软件使用判断', '软件使用评估',
            '软件使用衡量', '软件使用权衡', '软件使用比较', '软件使用对比', '软件使用参考', '软件使用借鉴', '软件使用启发',
            '软件使用灵感', '软件使用创意', '软件使用思路', '软件使用方向', '软件使用趋势', '软件使用潮流', '软件使用风格',
            '软件使用特色', '软件使用特点', '软件使用特征', '软件使用属性', '软件使用性质', '软件使用品质', '软件使用质量',
            '软件使用水平', '软件使用档次', '软件使用等级', '软件使用级别', '软件使用标准', '软件使用规范', '软件使用规格'],
          weight: 1.0
        },
        { 
          path: '/page/resourse', 
          keywords: ['素材', '资源', '模型', '音乐', '视频', '图片', '纹理', '贴图', '动画素材', '3d模型', '音效', '配乐', '图标', '插件',
            '素材网站', '资源网站', '素材下载', '资源下载', '免费素材', '免费资源', '高质量素材', '高质量资源', '精品素材', '精品资源',
            '素材库', '资源库', '素材包', '资源包', '素材集', '资源集', '素材合集', '资源合集', '素材推荐', '资源推荐', '素材分享',
            '免费素材', '免版税', '资源整理', '素材收集', '图形图像', '图象', '三维素材', '二维素材', '贴图', 'hdr贴图',
            '资源分类', '素材标签', '资源标签', '动画资源', '设计资源', '创作资源', '学习资源', '教程资源', '软件资源', '工具资源',
            '参考资源', '灵感资源', '声音', '配音', '行业资源', '优质资源', '精选资源', '推荐资源', '热门资源', '最新资源',
            '更新资源', '分享资源', '下载资源', '在线资源', '离线资源', '角色动画', '动作库', '动捕', '视频背景', '付费资源',
            'VIP资源', '会员资源', '独家资源', '限时资源', '限量资源', '特供资源', '专属资源', '珍藏资源', '珍贵资源', '稀有资源',
            '经典资源', '优秀资源', '游戏音效', '精品资源', '高端资源', '高级资源', '专业资源', '商业资源', '商用资源', '版权资源',
            '授权资源', '电影下载', '音乐下载', '原创资源', '二次创作资源', '改编资源', '衍生资源', '联动资源', '合作资源', '共享资源',
            '交流资源', '互换资源', '置换资源', '作品集', '简历模板', '简历制作', '出租资源', '出售资源', '购买资源', '收购资源',
            '求购资源', '求售资源', '求租资源', '求借资源', '求换资源', '求购资源', '求售资源', '求租资源', '求借资源', '求换资源'],
          weight: 1.0
        },
        { 
          path: '/page/byjy', 
          keywords: ['毕业', '就业', '论文', '实习', '作品集', '简历', '求职', '招聘', '面试', '论文格式', '毕业设计', '文献查找',
            '就业指导', '参考文献', '就业辅导', '就业培训', '就业推荐', '就业推送', '就业信息', '就业资讯', '就业政策', '就业形势',
            '就业前景', '就业方向', '就业规划', '就业计划', '就业目标', '就业准备', '就业技巧', '就业经验', '就业分享', '就业心得',
            '就业总结', '就业反馈', '就业评价', '就业建议', '就业指南', '就业攻略', '就业秘籍', '就业宝典', '就业指南', '就业攻略',
            '毕业要求', '毕业条件', '毕业资格', '毕业审核', '毕业答辩', '毕业典礼', '毕业证书', '毕业证明', '毕业手续', '毕业流程',
            '毕业材料', '毕业资料', '毕业档案', '毕业文件', '毕业相关', '毕业事项', '毕业注意', '毕业提醒', '毕业通知', '毕业安排',
            '作品集制作', '作品集设计', '作品集整理', '作品集修改', '作品集优化', '作品集完善', '作品集提升', '作品集改进', '作品集建议',
            '作品集评价', '作品集点评', '作品集分析', '作品集指导', '作品集咨询', '作品集辅导', '作品集培训', '作品集课程', '作品集教程',
            '简历制作', '简历设计', '简历模板', '一起论文', '校友帮', '论文查重', '简历指导', '简历修改', '简历优化', '简历完善',
            '求职技巧', '求职经验', '求职分享', '求职心得', '求职总结', '求职反馈', '求职评价', '求职建议', '求职指南', '求职攻略',
            '面试技巧', '面试经验', '面试分享', '面试心得', '面试总结', '面试反馈', '面试评价', '面试建议', '面试指南', '面试攻略'],
          weight: 1.0
        },
        { 
          path: '/page/rcbg', 
          keywords: ['教师考核', '办公', '申请', '作业提交', '表格', '文档', '通知', '调课', '外出实践', '请假', '考勤',
            '日常工作', '日常事务', '日常管理', '日常安排', '科研信息', '日常总结', '日常报告', '日常汇报', '日常记录', '日常备忘',
            '办公软件', '办公设备', '教务选课', '办公环境', '办公条件', '办公要求', '办公规范', '办公制度', '办公流程', '办公规则',
            '申请材料', '申请流程', '申请要求', '申请规范', '申请说明', '申请指南', '申请攻略', '申请技巧', '申请经验', '申请分享',
            '流程规范', '流程要求', '流程说明', '流程指南', '流程攻略', '流程技巧', '流程经验', '流程分享', '流程优化', '流程改进',
            '表格模板', '表格填写', '表格要求', '表格规范', '表格说明', '表格指南', '表格攻略', '表格技巧', '表格经验', '表格分享',
            '文档模板', '文档编写', '文档要求', '文档规范', '文档说明', '文档指南', '文档攻略', '文档技巧', '文档经验', '文档分享',
            '通知发布', '通知要求', '通知规范', '通知说明', '通知指南', '通知攻略', '通知技巧', '通知经验', '通知分享', '通知模板',
            '规章制度', '规章要求', '规章规范', '规章说明', '规章指南', '规章攻略', '规章技巧', '规章经验', '规章分享', '规章模板',
            '实践要求', '实践规范', '实践说明', '实践指南', '实践攻略', '实践技巧', '实践经验', '实践分享', '实践总结', '实践报告'],
          weight: 1.0
        },
        { 
          path: '/page/vr', 
          keywords: ['虚拟', '展馆', 'vr', '3d', '虚拟现实', '展览', '展示', '数字展厅', '虚拟展示', '3d展示',
            '虚拟技术', '虚拟场景', '虚拟空间', '虚拟环境', '虚拟世界', '虚拟漫游', '虚拟体验', '虚拟交互', '虚拟展览', '虚拟展厅',
            '展馆设计', '展馆布局', '展馆规划', '展馆效果', '展馆风格', '展馆特色', '展馆亮点', '展馆创意', '展馆互动', '展馆体验',
            '3D建模', '3D场景', '3D空间', '3D环境', '3D效果', '3D渲染', '3D展示', '3D漫游', '3D交互', '3D体验',
            'VR技术', 'VR场景', 'VR空间', 'VR环境', 'VR效果', 'VR渲染', 'VR展示', 'VR漫游', 'VR交互', 'VR体验',
            '数字展示', '数字场景', '数字空间', '数字环境', '数字效果', '数字渲染', '数字漫游', '数字交互', '数字体验', '数字创意'],
          weight: 1.0
        }
      ];
      
     // 计算每个路由的匹配分数
      const routeScores = routes.map(route => {
        let score = 0;
        
        // 完全匹配关键词
        const exactMatches = route.keywords.filter(keyword => 
          keyword === query
        ).length;
        score += exactMatches * 10 * route.weight; // 完全匹配给予高分
        
        // 关键词包含查询词
        const containsMatches = route.keywords.filter(keyword => 
          keyword.includes(query) && keyword !== query
        ).length;
        score += containsMatches * 5 * route.weight; // 包含匹配给予中等分数
        
        // 查询词包含关键词
        const includedInMatches = route.keywords.filter(keyword => 
          query.includes(keyword) && keyword !== query
        ).length;
        score += includedInMatches * 3 * route.weight; // 被包含匹配给予较低分数
        
        // 模糊匹配 - 计算编辑距离
        const fuzzyMatches = route.keywords.filter(keyword => {
          // 简单的编辑距离计算 - 如果关键词长度与查询词相差太多，直接跳过
          if (Math.abs(keyword.length - query.length) > 3) return false;
          
          // 计算相似度 (简化版的编辑距离)
          let similarity = 0;
          const minLength = Math.min(keyword.length, query.length);
          for (let i = 0; i < minLength; i++) {
            if (keyword[i] === query[i]) similarity++;
          }
          
          // 相似度超过50%则认为是模糊匹配
          return similarity / minLength > 0.5;
        }).length;
        score += fuzzyMatches * 2 * route.weight; // 模糊匹配给予较低分数
        
        return { path: route.path, score };
      });
      
      // 按分数排序并获取最高分的路由
      routeScores.sort((a, b) => b.score - a.score);
      const bestMatch = routeScores[0].score > 0 ? routeScores[0].path : null;
      
      if (bestMatch) {
        this.$router.push(bestMatch);
        this.searchQuery = '';
      }
    }
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.top-nav-container {
  background-color: #f5f7fa;
  position: relative;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  margin-bottom: 0; /* 确保与下方元素无间距 */
  width: 100%; /* 确保容器全屏 */
}

/* 添加 slider-wrapper 样式 */
.slider-wrapper {
  line-height: 0; /* 消除可能的行高间距 */
  display: block;
  margin-top: 1.9%;
  padding: 0;
}

.top-nav {
  padding: 8px 0px;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  width: 100%;
  margin: 0 auto;
}

.top-nav-toggle {
  display: none;
  background-color: #f5f7fa;
  border: none;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: background-color 0.3s ease;
}

.top-nav-toggle:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.toggle-icon {
  margin-left: 5px;
  font-size: 9px;
  transition: transform 0.3s ease;
}

.toggle-icon.open {
  transform: rotate(180deg);
}

.top-nav-link {
  color: #2c3e50;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
  padding: 2px 0;
}

.top-nav-link:hover {
  color: #4285f4;
}

.top-nav-link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #4285f4;
  transition: width 0.3s ease;
}

.top-nav-link:hover::after {
  width: 100%;
}

.search-container {
  background: linear-gradient(135deg, #4285f4, #5b9aff);
  padding: 15px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 0; /* 确保与上下元素无间距 */
}

.search-box {
  display: flex;
  width: 75%;
  max-width: 550px;
  position: relative;
}

.search-input {
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
}

.search-input:focus {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.25), 0 4px 10px rgba(0, 0, 0, 0.15);
  outline: none;
}

.search-button {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 16px;
  background: none;
  border: none;
  cursor: pointer;
  color: #5f6368;
  transition: color 0.3s ease;
}

.search-button:hover {
  color: #4285f4;
}

.search-icon {
  font-style: normal;
  font-size: 16px;
}

.quick-links {
  display: flex;
  gap: 16px;
}

.quick-link {
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.1);
}

.quick-link:hover {
  background-color: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.navbar {
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  padding: 0;
  position: relative;
  margin-top: 0; /* 确保与上方元素无间距 */
}

.navbar ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
}

.navbar li {
  margin: 0;
  padding: 0;
}

.navbar li a {
  display: block;
  padding: 15px 20px;
  color: #2c3e50;
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s ease;
  position: relative;
}

.navbar li a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background-color: #4285f4;
  transition: width 0.3s ease, left 0.3s ease;
}

.navbar li a:hover, .navbar li a.active {
  color: #4285f4;
}

.navbar li a:hover::after, .navbar li a.active::after {
  width: 100%;
  left: 0;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 12px;
  position: absolute;
  right: 12px;
  top: 6px;
  z-index: 100;
}

.mobile-menu-btn span {
  display: block;
  width: 22px;
  height: 2px;
  background-color: #2c3e50;
  margin: 4px 0;
  transition: all 0.3s ease;
}

.mobile-menu-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* 添加登录/注册模态框样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
  overflow-y: auto; /* 允许在小屏幕上滚动 */
  padding: 20px 0; /* 确保在小屏幕上有一些内边距 */
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 480px;
  position: relative;
  overflow: hidden;
  animation: slideIn 0.3s ease;
  margin: auto; /* 确保在所有屏幕尺寸上居中 */
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  transition: color 0.3s ease;
  z-index: 10;
  width: 30px; /* 增加触摸区域 */
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 50%;
}

.close-btn:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.05);
}

/* 登录表单样式 */
.login-container, .register-container {
  padding: 30px;
}

.login-form, .register-form {
  margin-bottom: 20px;
}

.login-form h2, .register-form h2 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  font-size: 24px;
  text-align: center;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
}

.form-group input {
  width: 100%;
  padding: 12px; /* 增加高度以便于触摸 */
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px; /* 增加字体大小以便于移动端阅读 */
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  -webkit-appearance: none; /* 移除iOS默认样式 */
  appearance: none;
}

.form-group input:focus {
  border-color: #4285f4;
  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
  outline: none;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.checkbox-label input {
  margin-right: 8px;
  width: auto;
  min-width: 18px; /* 增加触摸区域 */
  min-height: 18px;
}

.checkbox-label span {
  font-size: 15px; /* 增加字体大小 */
}

.login-button, .register-button, .social-btn {
  width: 100%;
  padding: 14px; /* 增加高度以便于触摸 */
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  -webkit-appearance: none; /* 移除iOS默认样式 */
  appearance: none;
}

.login-button:hover, .register-button:hover {
  background-color: #3367d6;
  transform: translateY(-2px);
}

.login-button:disabled, .register-button:disabled {
  background-color: #a0c3ff;
  cursor: not-allowed;
  transform: none;
}

.form-footer {
  text-align: center;
  margin-top: 20px;
  color: #666;
}

.form-footer a {
  color: #4285f4;
  text-decoration: none;
  font-weight: 500;
  padding: 5px; /* 增加触摸区域 */
}

.error-message, .success-message {
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
}

.error-message {
  background-color: #ffebee;
  color: #d32f2f;
  border: 1px solid #ffcdd2;
}

.success-message {
  background-color: #e8f5e9;
  color: #388e3c;
  border: 1px solid #c8e6c9;
}

/* 密码强度指示器 */
.password-strength {
  margin-top: 8px;
}

.strength-bar {
  height: 5px;
  background-color: #eee;
  border-radius: 3px;
  overflow: hidden;
}

.strength-level {
  height: 100%;
  transition: width 0.3s ease, background-color 0.3s ease;
}

.strength-level.weak {
  background-color: #f44336;
}

.strength-level.medium {
  background-color: #ff9800;
}

.strength-level.strong {
  background-color: #4caf50;
}

.strength-text {
  display: block;
  text-align: right;
  font-size: 12px;
  margin-top: 4px;
  color: #666;
}

/* 动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { transform: translateY(-20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* 移动端优化 */
@media screen and (max-width: 768px) {
  .modal-content {
    width: 95%;
    max-width: 400px;
  }
  
  .login-container, .register-container {
    padding: 20px;
  }
  
  .social-buttons {
    flex-direction: column;
  }
  
  .auth-links {
    flex-direction: column;
    gap: 8px;
  }
  
  .top-nav-toggle {
    display: flex;
  }
  
  .top-nav {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    flex-direction: column;
    align-items: center;
    padding: 0;
    gap: 0;
    position: absolute; /* 添加绝对定位 */
    top: 100%; /* 位于容器下方 */
    left: 0;
    right: 0;
    background-color: #f5f7fa;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    z-index: 99; /* 确保在其他元素上方 */
  }
  
  .top-nav.show-top-nav {
    max-height: 180px;
    padding: 8px 0;
  }
  
  .top-nav-link {
    padding: 12px 16px; /* 增加内边距，与navbar一致 */
    width: 100%;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  }
  
  .top-nav-link:last-child {
    border-bottom: none;
  }
  
  .mobile-menu-btn {
    display: block;
  }
  
  .navbar ul {
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    z-index: 99;
  }
  
  .navbar ul.show-mobile-menu {
    max-height: 280px;
  }
  
  .search-box {
    width: 85%;
  }
  
  .quick-links {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  
  .navbar li a {
    padding: 12px 16px;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  }
  
  .navbar li:last-child a {
    border-bottom: none;
  }

  .slider-wrapper {
    margin-top: -2px;
  }
}

/* 小屏幕手机优化 */
@media screen and (max-width: 480px) {
  .modal {
    align-items: flex-start; /* 在小屏幕上从顶部开始 */
    padding: 10px;
  }
  
  .modal-content {
    width: 100%;
    max-height: 90vh; /* 限制高度以允许滚动 */
    overflow-y: auto;
  }
  
  .login-container, .register-container {
    padding: 20px 15px;
  }
  
  .login-form h2, .register-form h2 {
    font-size: 20px;
    margin-bottom: 15px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-group label {
    font-size: 14px;
  }
  
  .form-group input {
    padding: 10px;
    font-size: 15px;
  }
  
  .login-button, .register-button {
    padding: 12px;
  }
  
  .close-btn {
    top: 10px;
    right: 10px;
  }
  
  .navbar li a {
    padding: 10px 12px;
    font-size: 14px;
  }
  
  .search-box {
    width: 90%;
  }
  
  .search-input {
    padding: 8px 12px;
  }
  
  .quick-link {
    font-size: 13px;
    padding: 4px 8px;
  }
}

/* 确保在iOS设备上输入框正常显示 */
@supports (-webkit-touch-callout: none) {
  .form-group input {
    font-size: 16px; /* 防止iOS缩放 */
  }
  
  .modal {
    -webkit-overflow-scrolling: touch; /* 增强iOS滚动体验 */
  }
}

/* 处理横屏模式 */
@media screen and (max-height: 480px) and (orientation: landscape) {
  .modal {
    align-items: flex-start;
    padding: 5px;
  }
  
  .modal-content {
    max-height: 95vh;
  }
  
  .login-container, .register-container {
    padding: 15px 12px;
  }
  
  .form-group {
    margin-bottom: 10px;
  }
  
  .login-form h2, .register-form h2 {
    font-size: 18px;
    margin-bottom: 12px;
  }
}

/* 处理高分辨率设备 */
@media screen and (min-width: 1200px) {
  .modal-content {
    max-width: 500px;
  }
  
  .login-container, .register-container {
    padding: 35px;
  }
}

/* 处理触摸设备的悬停状态 */
@media (hover: hover) {
  .login-button:hover, .register-button:hover {
    background-color: #3367d6;
    transform: translateY(-2px);
  }
  
  .top-nav-link:hover::after {
    width: 100%;
  }
}

/* 处理非触摸设备 */
@media (hover: none) {
  .login-button:active, .register-button:active {
    background-color: #3367d6;
    transform: translateY(1px);
  }
  
  .top-nav-link:active {
    color: #4285f4;
  }
}

/* 新增样式 */
.loading-indicator {
  display: inline-block;
  animation: spin 1s linear infinite;
  margin-left: 5px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.user-info {
  cursor: help;
  position: relative;
}

.error-message {
  color: #ff4757;
  background-color: #ffe0e0;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 15px;
  font-size: 14px;
  border: 1px solid #ffcdd2;
}

.checkbox-group {
  display: flex;
  align-items: center;
  margin: 15px 0;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
}

.checkbox-label input[type="checkbox"] {
  margin-right: 8px;
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}


</style>